module.exports = __webpack_public_path__ + "static/media/lowlands.fcaeb075.jpg";